import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-b', 'LetterB', [["path",{"d":"M9 12V7h4.589c2.74 0 3.124 4.072.57 5M9 12v5h4.589c2.74 0 3.124-4.072.57-5M9 12h5.158","key":"svg-0"}]]);